
import {getdevicetype, queryvirtualroom, adddevice, set902device, addvirtualroom} from '../../api/device'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import store from '../../store/store'

export default {
name: 'addDevice',
directives: {
TransferDom
},
data () {
return {
showSuc: false,
showSucText: '',
showErr: false,
showErrText: '设备类型失败',
isShowOnline: false,
device: {},
addDevice: {
deviceid: '',
devicephone: '',
name: '',
relativeadd: '',
roomid: '',
areaid: '',
sosphone: '',
phone1: '',
phone2: ''
},
imgArr: [],
allFamilyRoom: [],
allFamily: [],
selectRooms: [],
isSend: true,

sendFamily: {
name: '',
userName: '',
level: 1,
parentid: 0
},
addFamilyShow: false,
hotName1: [{name: '我的家'}, {name: '我的公司'}, {name: '门店'}, {name: '父母家'}],
selectHot1: '',

hotName2: [{name: '客厅'}, {name: '主卧'}, {name: '次卧'}, {name: '房间'}, {name: '卫生间'}, {name: '厨房'}, {name: '大门'}],
selectHot2: '',
addRoomShow: false,
sendRoom: {
name: ''
}
}
},
created () {
this.imgArr = this.common.getAddImg()

if (this.$store.getters.get_adddeviceid !== '') {
this.addDevice.deviceid = this.$store.getters.get_adddeviceid
this.getDeviceTypeObj()
}
this.getAllRooms()
document.getElementsByTagName('title')[0].innerText = '添加设备'
if (['18676738514', '13760203721', '13829597323', '13682300127', '15305626610', '13760286454', '18112545657', '18025366812'].indexOf(store.getters.get_user) !== -1) {
this.isShowOnline = true
}
},
beforeDestroy () {
document.getElementsByTagName('title')[0].innerText = '智慧安防'
},
methods: {
isShowSelfPhone () {

var arr = [700, 200, 800, 901, 902]
return arr.indexOf(this.device.dtype) >= 0
},
isShowMoreInfo () {

var arr = [700, 200, 800, 901, 902]
return arr.indexOf(this.device.dtype) >= 0
},
openSubscribeSuccess (e) {
alert('成功')
this.showToast = false
this.showAddText = true
},
openSubscribeError (e) {
alert('订阅失败', JSON.stringify(e).detail.errMsg)
this.showToast = false
},
scanner () {
let vm = this

wx.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
success (res) {

if (res.resultStr.includes('IMEI=')) {
let result = res.resultStr.split('IMEI=')

let code = result[1]
if (code) {
vm.addDevice.deviceid = code
}
} else if (res.resultStr.includes('imei=')) {
let result = res.resultStr.split('imei=')

let code = result[1]
if (code) {
vm.addDevice.deviceid = code
}
} else if (res.resultStr.includes('CODE_128,')) {
let result = res.resultStr.split('CODE_128,')

let code = result[1]
if (code) {
vm.addDevice.deviceid = code
}
} else {
vm.addDevice.deviceid = res.resultStr
}
vm.getDeviceTypeObj()
},
error (err) {
alert(JSON.stringify(err))
}
})
},
getDeviceTypeObj () {
if (this.addDevice.deviceid.length < 10 || this.addDevice.deviceid.length > 15) {
this.$toast('请输入完整的设备码')
return
}
let data = {
imei: this.addDevice.deviceid
}
getdevicetype(data).then(res => {
if (res.code === 200) {
let arr = res.data !== null ? res.data : []
this.device = ''
for (let i = 0; i < arr.length; i++) {
if (this.addDevice.deviceid === arr[i].deviceid) {
this.device = arr[i]
console.log(this.device)
}
}
if (arr.length === 0) {
this.$toast('设备不存在或已绑定')
}
} else {
this.showErr = true
this.showErrText = res.msg
}
}).catch(() => {
this.showErr = true
this.showErrText = '设备类型失败'
})
},

getAllRooms () {
this.selectRooms = []
this.allFamily = []
this.allFamilyRoom = []
queryvirtualroom().then(res => {
if (res.code === 200) {

let arr = res.data !== null ? res.data : []
this.allFamilyRoom = arr
for (let i = 0; i < arr.length; i++) {
if (arr[i].role === 'owner') {
this.allFamily.push(arr[i])
}
}
if (this.allFamily.length > 0 && this.addDevice.areaid === '') {
this.addDevice.areaid = this.allFamily[0].id
}
for (let i = 0; i < arr.length; i++) {
if (this.addDevice.areaid === arr[i].parentid) {
this.selectRooms.push(arr[i])
}
}
} else {
this.showErr = true
this.showErrText = res.msg
}
}).catch(() => {
this.showErr = true
this.showErrText = '获取场所失败'
})
},

blurCode () {
console.log(12314)
this.getDeviceTypeObj()





},

blurDname () {
console.log(1111)





if (this.addDevice.name === '') {
return
}
if (this.addDevice.name.length > 12) {
this.$toast('设备名称不能大于12个字符。')
}
},
blurRelative () {
if (this.addDevice.relativeadd === '') {
return
}
if (this.addDevice.relativeadd.length > 20) {
this.$toast('提醒标识不能大于20个字符。')
}
},
changeArea (item) {
if (this.addDevice.roomid !== item.id) {
this.addDevice.areaid = item.id
let arr = this.allFamilyRoom
this.selectRooms = []
this.addDevice.roomid = ''
for (let i = 0; i < arr.length; i++) {
if (this.addDevice.areaid === arr[i].parentid) {
this.selectRooms.push(arr[i])
}
}
}





},
changeRoom (item) {
if (this.addDevice.roomid === item.id) {
this.addDevice.roomid = ''
} else {
this.addDevice.roomid = item.id
}
},
changeEmpty (text) {
if (text === 'name') {
this.addDevice.name = ''
} else if (text === 'relativeadd') {
this.addDevice.relativeadd = ''
} else if (text === 'devicephone') {
this.addDevice.devicephone = ''
} else if (text === 'sosphone') {
this.addDevice.sosphone = ''
} else if (text === 'phone1') {
this.addDevice.phone1 = ''
} else if (text === 'phone2') {
this.addDevice.phone2 = ''
}
},

getImageUrl (dtype) {
let key = parseInt(dtype)
let imgdata = this.imgArr
let img = imgdata[this.imgArr.length - 1].imgUrl
for (let i = 0; i < imgdata.length; i++) {
if (imgdata[i].dtype === key) {
img = imgdata[i].imgUrl
}
}
return img
},
getDeviceOnlineStyle () {
let result = ''
if (this.device) {
let isOnline = this.device.is_online
if (isOnline === 1) {
result = 'color: #0bb20c'
} else if (isOnline === 0) {
result = 'color: #e60000'
}
}
return result
},
getDeviceOnline () {
let result = ''
if (this.device && this.device.last_online) {
result = this.device.last_online
let isOnline = this.device.is_online
if (isOnline === 1) {
result += ' 在线'
} else if (isOnline === 0) {
result += ' 离线'
} else {
result += ' 未知'
}
}
return result
},
backPage () {
if (this.$store.getters.get_adddeviceid !== '') {
this.$router.push('/home')
} else {
this.$router.go(-1)
}
},
sendAddDevice () {
if (this.addDevice.deviceid === '' || this.addDevice.name === '' || this.addDevice.areaid === '') {
this.$toast('设备码、设备名称或场所不能为空！')
return
}
if (this.addDevice.name.length > 12) {
this.$toast('设备名称不能大于12个字符。')
return
}
if (this.addDevice.relativeadd.length > 20) {
this.$toast('提醒标识不能大于20个字符。')
return
}
let data = {
deviceid: this.addDevice.deviceid,
devicephone: this.addDevice.devicephone,
name: this.addDevice.name,
relativeadd: this.addDevice.relativeadd,
areaid: this.addDevice.areaid,
roomid: this.addDevice.roomid
}
if (data.roomid === '') {
data.roomid = 0
}
adddevice(data).then(res => {
if (res.code === 200) {
if (this.device.dtype !== 902) {
this.showSuc = true
this.showSucText = '成功'
let vm = this
setTimeout(() => {
if (vm.$store.getters.get_adddeviceid !== '') {
vm.$router.push('/home')
} else {
vm.$router.go(-1)
}
}, 500)
} else {
this.setDevicePhone()
}
} else {
this.showErr = true
this.showErrText = res.msg
}
}).catch(() => {
this.showErr = true
this.showErrText = '失败'
})
},

setDevicePhone () {
if (this.addDevice.phone1 === '' && this.addDevice.phone2 === '' && this.addDevice.sosphone === '') {
this.showSuc = true
this.showSucText = '成功'
let vm = this
setTimeout(() => {
if (vm.$store.getters.get_adddeviceid !== '') {
vm.$router.push('/home')
} else {
vm.$router.go(-1)
}
}, 1000)
return
}
let data = {
imei: this.addDevice.deviceid,
phone1: this.addDevice.phone1,
phone2: this.addDevice.phone2,
sosphone: this.addDevice.sosphone
}
set902device(data).then(res => {
if (res.code === 200) {
this.showSuc = true
this.showSucText = '成功'
let vm = this
setTimeout(() => {
if (vm.$store.getters.get_adddeviceid !== '') {
vm.$router.push('/home')
} else {
vm.$router.go(-1)
}
}, 500)
} else {
this.showErr = true
this.showErrText = res.msg
}
}).catch(() => {
this.showErr = true
this.showErrText = '失败'
})
},

addFamily () {
this.sendFamily.name = ''
this.sendFamily.userName = ''
this.addFamilyShow = true
},
selectHotName1 (item) {
if (this.selectHot1 !== item.name) {
this.selectHot1 = item.name
this.sendFamily.name = this.selectHot1
} else {
this.selectHot1 = ''
this.sendFamily.name = ''
}
},
addHome () {
addvirtualroom(this.sendFamily).then(res => {
if (res.code === 200) {
this.getAllRooms()
this.addDevice.areaid = res.data
this.showSuc = true
this.showSucText = '成功'
this.addFamilyShow = false
} else {
this.showErr = true
this.showErrText = res.msg
}
}).catch(() => {
this.showErr = true
this.showErrText = '失败'
})
},

addRoomOpen () {
this.addRoomShow = true
},
selectHotName2 (item) {
if (this.selectHot2 !== item.name) {
this.selectHot2 = item.name
this.sendRoom.name = this.selectHot2
} else {
this.selectHot2 = ''
this.sendRoom.name = ''
}
},
addRoomSend () {
let data = {
name: this.sendRoom.name,
level: 2,
parentid: this.addDevice.areaid
}
addvirtualroom(data).then(res => {
if (res.code === 200) {
this.getAllRooms()
this.addDevice.roomid = res.data
this.showSuc = true
this.showSucText = '成功'
this.addRoomShow = false
} else {
this.showErr = true
this.showErrText = res.msg
}
}).catch(() => {
this.showErr = true
this.showErrText = '失败'
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/addDevice/addDevice.vue